// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"585":"49c2a7c9","832":"d13204d3"}[chunkId] + ".chunk.js");